module.exports = __webpack_public_path__ + "img/signal-start.6f0cfed0.svg";